import { useMergedStyles } from '#src/hooks';

import localStyles from './styles.module.scss';

const getYear = () => {
  const date = new Date();

  return date.getFullYear();
};

export const Copyright = ({
  companyLegalName,
  copyrightStartYear,
  styles: stylesProp,
}) => {
  const styles = useMergedStyles(localStyles, stylesProp);
  return (
    <div className={styles.text}>
      ©{copyrightStartYear}&ndash;{getYear()} {companyLegalName}
    </div>
  );
};
